<div class="grid grid--va-middle">
  <div class="grid__box grid__box--size-min grid__box--pull-left">
    <div class="grid grid--va-middle">
      <div class="grid__box grid__box--size-min">
        <span class="title">Заявки</span>
      </div>
      <div class="grid__box grid__box--size-min">
        <div *ngIf="ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.assigned.counts === 0">
          <span class="color-blue-dark"> Назначено ({{ ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.assigned.counts }}) </span>
        </div>
      </div>
      <div class="grid__box grid__box--size-min">
        <div *ngIf="ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.unassigned.counts === 0">
          <span class="color-red-dark"> Не назначено ({{ ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.unassigned.counts }}) </span>
        </div>
        <div *ngIf="ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.unassigned.counts > 0">
          <span class="color-red-dark font-weight-bold" *ngIf="ticketsCurrentFilter.currentFilterTypeSelected.id === 'unassigned'">
            Не назначено ({{ ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.unassigned.counts }})
          </span>
          <a class="link link--dotted-red-dark" (click)="onChangeTicketType('unassigned')" *ngIf="ticketsCurrentFilter.currentFilterTypeSelected.id !== 'unassigned'">
            Не назначено ({{ ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.unassigned.counts }})
          </a>
        </div>
      </div>
      <div class="grid__box grid__box--size-min">
        <div *ngIf="ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.assigned.counts === 0">
          <span class="color-blue-dark"> Назначеные на бригады ({{ ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.assigned.counts }}) </span>
        </div>
        <div *ngIf="ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.assigned.counts > 0">
          <span class="color-blue-dark font-weight-bold" *ngIf="ticketsCurrentFilter.currentFilterTypeSelected.id === 'assigned'">
            Назначеные на бригады ({{ ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.assigned.counts }})
          </span>
          <a class="link link--dotted-blue-dark" (click)="onChangeTicketType('assigned')" *ngIf="ticketsCurrentFilter.currentFilterTypeSelected.id !== 'assigned'">
            Назначеные на бригады ({{ ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.assigned.counts }})
          </a>
        </div>
      </div>
      <div class="grid__box grid__box--size-min">
        <div *ngIf="ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.needActions.counts === 0">
          <span class="color-red-dark"> Просроченные ({{ ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.needActions.counts }}) </span>
        </div>
        <div *ngIf="ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.needActions.counts > 0">
          <span class="color-red-dark font-weight-bold" *ngIf="ticketsCurrentFilter.currentFilterTypeSelected.id === 'needActions'">
            Просроченные ({{ ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.needActions.counts }})
          </span>
          <a class="link link--dotted-red-dark" (click)="onChangeTicketType('needActions')" *ngIf="ticketsCurrentFilter.currentFilterTypeSelected.id !== 'needActions'">
            Просроченные ({{ ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.needActions.counts }})
          </a>
        </div>
      </div>
      <div class="grid__box grid__box--size-min">
        <button
          type="button"
          class="button"
          [disabled]="(brigadeAssign && brigadeAssign.brigades && !brigadeAssign.brigades.length) || brigadeAssign?.isAssignedLoading"
          (click)="assignBrigades()"
        >
          Отправить в работу
        </button>
      </div>
      <div
        class="grid__box grid__box--size-min"
        *ngIf="brigadeAssign && brigadeAssign.brigades && brigadeAssign.brigades.length && !brigadeAssign?.isAssignedSuccess && !brigadeAssign?.isAssignedLoading"
      >
        <span class="text-italic color-gray-dark">
          Заявки на отправку:
          {{ brigadeAssign && brigadeAssign.brigades && brigadeAssign.brigades.length }}
        </span>
      </div>
      <div class="grid__box grid__box--size-min" *ngIf="brigadeAssign?.isAssignedLoading">
        <div class="pos-r">
          <app-loader [size]="'small'" [position]="'reset'"></app-loader>
        </div>
      </div>
      <div class="grid__box grid__box--size-min" *ngIf="brigadeAssign && brigadeAssign?.isAssignedSuccess && !brigadeAssign?.isAssignedLoading">
        <span class="text-italic color-green-dark">Заявки отправлены</span>
      </div>
    </div>
  </div>
  <div class="grid__box grid__box--pull-right grid__box--flex grid__box--justify-content-flex-end">
    <div class="grid__box grid__box--size-min grid__box--pull-right">
      <div class="grid grid--va-middle grid--gap-4">
        <div class="grid__box grid__box--size-min">
          <app-icon [glyph]="'update'" [size]="'16'" [class]="'icon--va-middle'" [color]="'gray-dark'"></app-icon>
        </div>
        <div class="grid__box grid__box--size-min">
          <a class="link link--dotted-blue-dark" (click)="ticketsCurrentFilter.applyFilter()">Обновить список заявок</a>
        </div>
      </div>
    </div>
    <div class="grid__box grid__box--size-min ta-right">
      <a class="link link--dotted-gray" [ngbPopover]="LegendPopContent" placement="bottom-right" #p2="ngbPopover">Легенда</a>
    </div>
  </div>
</div>

<ng-template #LegendPopContent>
  <ul class="ticket-icons-list">
    <li *ngFor="let ticketIcon of ticketIconsMap | func: filterIconMap" class="ticket-icons-list__item">
      <img [attr.src]="ticketIcon.path" class="ticket-icons-list__image" alt="" />
      {{ ticketIcon.name }}
    </li>
  </ul>
</ng-template>
